import { SFTPUserDTO } from "../DTO/sftpUserDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateSFTPUserRequest extends BasicRequest{
    public sftpUser! : SFTPUserDTO;

    constructor(){
        super()
    }
}